<template>
  <div class="wrapper">
      <h1>{{$t('menuName.companyBasic')}}</h1>
      <div>
        <ul>
          <li>{{$t('thisCompany.companyName')}}：{{thisCompanyInfo.name}}</li>
          <li>{{$t('thisCompany.companyCode')}}：{{thisCompanyInfo.code}}</li>
          <li>appKey：{{thisCompanyInfo.appKey}}</li>
          <li>appSecret：{{thisCompanyInfo.appSecret}}</li>
          <li>{{$t('thisCompany.loginName')}}：{{thisCompanyInfo.userName}}</li>
          <li>{{$t('thisCompany.niceName')}}：{{thisCompanyInfo.displayName}}</li>
          <li>{{$t('thisCompany.phone')}}：{{thisCompanyInfo.phone}}</li>
          <li>项目名称：{{thisCompanyInfo.modelName }}</li>
          <li>业务名称：{{thisCompanyInfo.businessName }}</li>
          <li>语言：{{thisCompanyInfo.language }}</li>
        </ul>
      </div>
  </div>
</template>

<script>
import {
  mycompanyInfo
} from "@/api/sys/companyList";
export default {
  data(){
    return{
        thisCompanyInfo:{}
    }
  },
  methods:{
    getCompanyInfo(){
      mycompanyInfo().then((res)=>{
        this.thisCompanyInfo = res.result
      })
    }
  },
  created(){
    this.getCompanyInfo();
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  margin: 50px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: 0.2s;
  padding: 20px;
}
ul,li{
  list-style: none;
}
li{
  padding:10px 0;
  border-bottom: 1px solid #ddd;
}
h1{
  text-align: center;
  color: #333;
}
</style>
